export default __webpack_public_path__ + "static/alert-ed60eea37fadf9b914d277582f618c8f.svg";